import React, { useState, useEffect } from 'react';

// 다국어
import { useTranslation } from 'react-i18next';
// @mui
import { styled } from '@mui/material/styles';
// Mui table
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import axios from 'axios';

import ProfileComponent from './ProfileComponent';

const StyledDiv = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '40px',
}));

const StyledDiv2 = styled('div')(() => ({
  backgroundColor: 'white',
  marginRight: '40px',
  padding: '30px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '10px',
  width: '20rem',
  height: '21rem',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
}));

const StyledDiv3 = styled('div')(() => ({
  backgroundColor: 'white',
  padding: '56px',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  borderRadius: '10px',
  flex: 1,
  '& h2': {
    marginBottom: '40px',
  },
}));

const StyledTableCell = styled(TableCell)(() => ({
  backgroundColor: 'white',
  borderTop: '1px solid #ddd;',
  color: 'black',
}));

export default function PaymentInfo({ data }) {
  // 다국어
  const { t, i18n } = useTranslation(['page']);

  const UserData = JSON.parse(sessionStorage.getItem('login_info'));
  const [userPaymentInfo, setUserPaymentInfo] = useState([]);
  const [userPaymentHistory, setUserPaymentHistory] = useState([]);

  useEffect(() => {
    // 데이터 체크
    if (UserData !== null) {
      axios
        .post(`${process.env.REACT_APP_SERVER_URL}/user/payment-info/${UserData.user_token}`)
        .then((response) => {
          //  console.log(response.data[0][0]);
          setUserPaymentInfo(response.data[0][0]);
        })
        .catch((response) => {
          console.log(response);
        });

      axios
        .post(`${process.env.REACT_APP_SERVER_URL}/user/payment-history/${UserData.user_token}`)
        .then((response) => {
          console.log('payment history', response.data);
          setUserPaymentHistory(response.data);
        })
        .catch((response) => {
          console.log(response);
        });
    }
  }, []);

  // 테이블값 만들기
  function createData(paymentPlan, cost, PaymentPeriod, cardNum) {
    return { paymentPlan, cost, PaymentPeriod, cardNum };
  }

  // --------------------------------------------------------- userPaymentInfo

  // ----------------------------------------------------------- {amountUsedList[0] != null && amountUsedList.count != null ? amountUsedList[0].count : 0}건/{licenseTypeUseInfo.receipt_cnt}건

  //  console.log("userPaymentInfo",userPaymentInfo);
  return (
    <div style={{ display: 'flex', padding: '0 10%' }}>
      <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
        <StyledDiv>
          <StyledDiv2>
            <ProfileComponent data={UserData} />
          </StyledDiv2>
          <StyledDiv3>
            <h2>{t('결제 정보')}</h2>

            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '40px' }}>
              <h3>{t('다음 결제일은')} </h3>
              <h4>
                {' '}
                {userPaymentInfo != null && userPaymentInfo.next_payment_date != null
                  ? userPaymentInfo.next_payment_date
                  : '0000-00-00'}{' '}
              </h4>
              <h3> {t('입니다.')}</h3>
            </div>

            <div>
              <table>
                <tbody>
                  <tr>
                    <td width="160px" style={{ fontWeight: '900' }}>
                      {t('서비스')}
                    </td>
                    <td>{t(UserData.use_license)}</td>
                  </tr>
                  {/* <tr>
                                <td width='100px' style={{fontWeight:'900'}}>기간</td>
                                <td>{userPaymentInfo != null && userPaymentInfo.count != null ? amountUsedList[0].count : "-"}</td>
                            </tr> */}
                  <tr>
                    <td width="160px" style={{ fontWeight: '900' }}>
                      {t('최근 결제일')}
                    </td>
                    <td>
                      {userPaymentInfo != null && userPaymentInfo.last_payment_date != null
                        ? userPaymentInfo.last_payment_date
                        : '-'}
                    </td>
                  </tr>
                  <tr>
                    <td width="160px" style={{ fontWeight: '900' }}>
                      {t('다음 예상 결제일')}
                    </td>
                    <td>
                      {userPaymentInfo != null && userPaymentInfo.next_payment_date != null
                        ? userPaymentInfo.next_payment_date
                        : '-'}
                    </td>
                  </tr>
                  {/* <tr>
                                <td width='100px' style={{fontWeight:'900'}}>결제정보</td>
                               
                            </tr> */}
                  <tr>
                    <td width="160px" style={{ fontWeight: '900' }}>
                      {t('결제기간')}
                    </td>
                    <td>
                      {userPaymentInfo != null && userPaymentInfo.is_subscription != null
                        ? userPaymentInfo.is_subscription
                        : '-'}
                    </td>
                  </tr>
                  <tr>
                    <td width="160px" style={{ fontWeight: '900' }}>
                      {t('등록 카드')}
                    </td>
                    <td>
                      {userPaymentInfo != null && userPaymentInfo.card_type != null ? userPaymentInfo.card_type : '-'}
                    </td>
                  </tr>
                  <tr>
                    <td width="160px" style={{ fontWeight: '900' }}>
                      {t('카드 번호')}
                    </td>
                    <td>
                      {userPaymentInfo != null && userPaymentInfo.card_number != null
                        ? userPaymentInfo.card_number
                        : '-'}
                    </td>
                  </tr>
                  {/* <tr>
                                <td width='100px' style={{fontWeight:'900'}}>라이센스</td>
                                <td>{userPaymentInfo != null && userPaymentInfo.use_license_type != null ? userPaymentInfo.use_license_type : "-"}</td>
                            </tr> */}
                  <tr>
                    <td width="160px" style={{ fontWeight: '900' }}>
                      {t('결제 상태')}
                    </td>
                    <td>
                      <span
                        style={{ backgroundColor: '#1A9EF8', borderRadius: '5px', color: '#fff', padding: '0.2rem' }}
                      >
                        {userPaymentInfo != null && userPaymentInfo.status != null ? t(userPaymentInfo.status) : '-'}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            {/* <Button>정기결제 중지</Button>
                <Button>등록 카드 변경</Button> */}
            <p style={{ margin: '30px 0 10px', fontWeight: '900' }}>{t('결제 내역')}</p>

            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="center">{t('플랜')}</StyledTableCell>
                    <StyledTableCell align="center">{t('금액')}</StyledTableCell>
                    <StyledTableCell align="center">{t('결제일')}</StyledTableCell>
                    <StyledTableCell align="center">{t('결과')}</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {userPaymentHistory.map((row, orderId) => (
                    <TableRow key={orderId} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                      <TableCell component="th" scope="row">
                        {row.orderName}
                      </TableCell>
                      <TableCell align="center">{row.totalAmount}</TableCell>
                      <TableCell align="center">{row.created_at}</TableCell>
                      <TableCell align="center">{row.status}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </StyledDiv3>
        </StyledDiv>
      </div>
    </div>
  );
}
